import { render, staticRenderFns } from "./drawerFiles.vue?vue&type=template&id=71034fe0&scoped=true&"
import script from "./drawerFiles.vue?vue&type=script&lang=js&"
export * from "./drawerFiles.vue?vue&type=script&lang=js&"
import style0 from "./drawerFiles.vue?vue&type=style&index=0&id=71034fe0&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71034fe0",
  null
  
)

export default component.exports